/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgClockWarning = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 12a8 8 0 0 1 15.938-1h2.013C21.449 5.947 17.185 2 12 2 6.477 2 2 6.477 2 12s4.477 10 10 10a9.956 9.956 0 0 0 6-2v-2.708A8 8 0 0 1 4 12z" />
        <path d="M22 13v7h-2v-7zm0 10h-2v-2h2zm-9-11.618V6h-2v6.618l4.553 2.276.894-1.788z" />
      </g>
    </g>
  </Icon>
);
export { SvgClockWarning as ClockWarning };
